'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.Info');

var _Container2 = _interopRequireDefault(_Container);

var _Icon = require('./components/Icon.Info');

var _Icon2 = _interopRequireDefault(_Icon);

var _Content = require('./components/Content.Info');

var _Content2 = _interopRequireDefault(_Content);

var _Undo = require('./components/Undo.Info');

var _Undo2 = _interopRequireDefault(_Undo);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Components


var getIcon = function getIcon(_ref) {
  var icon = _ref.icon,
      type = _ref.type;
  if (!!icon) return icon;

  switch (type) {
    case 'error':
      return 'closecircleo';

    case 'warning':
      return 'exclamationcircleo';

    case 'info':
      return 'infocirlceo';

    case 'success':
      return 'checkcircleo';

    default:
      return 'closecircleo';
  }
};

var Info = function Info(_ref2) {
  var type = _ref2.type,
      children = _ref2.children,
      action = _ref2.action,
      loading = _ref2.loading,
      flat = _ref2.flat,
      noIcon = _ref2.noIcon,
      icon = _ref2.icon;
  return _react2.default.createElement(_Container2.default, {
    type: type,
    flat: flat
  }, (!!icon || !noIcon && type !== 'plain') && _react2.default.createElement(_Icon2.default, {
    icon: loading ? 'loading2' : getIcon({
      icon: icon,
      type: type
    }),
    spin: loading
  }), _react2.default.createElement(_Content2.default, null, children), !!action && _react2.default.createElement(_Undo2.default, {
    onClick: action.onClick,
    invisible: loading
  }, action.label));
};

Info.propTypes = {
  type: _propTypes2.default.oneOf(['error', 'warning', 'info', 'success', 'plain']).isRequired,
  children: _propTypes2.default.node.isRequired,
  loading: _propTypes2.default.bool,
  action: _propTypes2.default.shape({
    label: _propTypes2.default.node.isRequired,
    onClick: _propTypes2.default.func.isRequired
  }),
  flat: _propTypes2.default.bool,
  noIcon: _propTypes2.default.bool,
  icon: _propTypes2.default.string
};
Info.defaultProps = {
  loading: false,
  action: null,
  flat: false,
  noIcon: false,
  icon: null
};
exports.default = Info;